<section class="container ">
  <div class="row mt-2 mb-3">
    <img src="/assets/images/landing/company-1.svg" class="w-100" alt="استخدام در شرکت‌های معتبر">
  </div>

  <form class="row text-center fs-normal -right align-items-center">
    <div class="col-12 col-md my-1 pr-md-0">
      <h2 for="search-what" class="text-right no-wrap my-auto ml-2 my-1 fs-lg">چه کاری؟</h2>
      <div class="w-100 ml-md-3 relative">
        <input id="search-what" name="q" maxlength="512" autocomplete="off" [(ngModel)]="params.q" appAutoFocus="true"
          class="" placeholder="عنوان شغلی، مهارت، نام شرکت، ..." />
        <i class="fa fa-search pl-2 fs-lg abs-middle left-0"></i>
      </div>
    </div>
    <div class="col-12 col-md my-1">
      <h2 for="search-where" class="text-right no-wrap my-auto ml-2 my-1 fs-lg">کجا؟</h2>
      <div class="w-100 ml-md-3 ">
        <app-location name="location" [(ngModel)]="location" placeholder="در سراسر کشور"></app-location>
      </div>
    </div>
    <div class="col-12 col-md my-2  pl-md-0 text-left fs-normal -right">
      <div class="row m-0 h-100 flex-grow-1 d-flex">
        <button type="submit" [routerLink]="['/company',params]" class="btn btn-yellow rounded-xl fs-lg flex-grow-1"
          ga-event="search|{{params.l}}|{{params.q}}" tabindex="0">
          جستجو در شرکت‌ها</button>
      </div>
    </div>
  </form>
</section>
<section class="container-fluid px-4 x-light-gray-bg pt-3 mt-2">
  <section class="container p-0">
    <div class="row">
      <h1 class="col h4">استخدام در شرکت‌های معتبر</h1>
    </div>
    <div class="row" infiniteScroll (scrolled)="loadMore()">
      <div class="col-12 col-md-4 col-lg-3 p-3" *ngFor="let user of users">
        <a class="d-block shadow-kp white-bg rounded-xl mx-auto p-3 text-center"
          [routerLink]="['/company',user.Employer.Code]">
          <img class="contain mw-100 mb-2 mx-auto" [src]="companyLogo(user.Employer.Logo)" [alt]="user.Employer.Company"
            style="width: 150px; height: 100px;" onerror="this.src='/assets/images/clipart/avatar-company-1.svg'" />
          <h2 class="fs-lg">{{user.Employer.Company}}</h2>
          <div class="btn btn-yellow fs-sm py-1">{{user.Employer._jobCount | number}} فرصت‌ شغلی</div>
        </a>
      </div>
    </div>
  </section>
</section>